// Read more about this way of fetching data
// https://redux.js.org/advanced/async-actions#actions-js-with-fetch

import {loadStationPumpsRequest, loadStationPumpsSuccess, deleteStationsRequest } from './actionCreators';
import fetch from 'cross-fetch'
import ApiService from '../services/api';
import { showSnackbar } from "../actions/snackbarActions";


export function loadStationPumps() {
  return (dispatch, getState) => {
    let state = getState();
    return dispatch(getStationPumps(state))
  }
}

function getStationPumps(state) {
  let token = state.oidc.user.access_token;

  return dispatch => {
    dispatch(loadStationPumpsRequest())
    return fetch(process.env.API_URL + '/api/Stations/Pumps', {
      headers: {
        'Authorization': 'Bearer ' + token
      }})
      .then(response => response.json())
      .then(json => dispatch(loadStationPumpsSuccess(json)))
  }
}

export const createNew = (content) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const token = state.oidc.user.access_token;
      let apiService = new ApiService(token);
      const newStation = await apiService.createNew("stations", content);
      const pumps = (newStation && newStation.stationPumpViewModels != null) ? newStation.stationPumpViewModels : null;
      dispatch({
        type: 'STATIONS_NEW_STATION',
        data: pumps
      })
    }
    catch (err) {
      throw Error(err);
    }
  }
}

export const editStation = (content) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const token = state.oidc.user.access_token;
      let apiService = new ApiService(token);
      const editedStation = await apiService.edit("stations", content);
      dispatch({
        type: 'STATIONS_EDIT_STATION',
        data: editedStation
      })
    }
    catch (err) {
      throw Error(err);
    }
  }
}

export const deleteStation = (content) => {
   return async (dispatch, getState) => {
      try {
        dispatch(deleteStationsRequest(true));
        const state = getState();
        const token = state.oidc.user.access_token;
        let apiService = new ApiService(token);
        const deletedStationId = await apiService.delete("stations", content);
        await dispatch({
          type: "STATIONS_DELETE_STATIONS",
          data: deletedStationId
        });
        dispatch(showSnackbar("Station deleted"))
        dispatch(deleteStationsRequest(false));
        dispatch(loadStationPumps(state))
      }
      catch (err) {
        dispatch(showSnackbar("Error: Station delete failed " + err.message));
        dispatch(deleteStationsRequest(false));
        //throw Error(err);
      }
    }
}


// Termporary solution for loading list
// of pumps for Modals. Currently,
// there aren't any existing implementations
// that allow assign the pumps to a variable.
export const loadPumpsAsync = () => {
  return async (dispatch, getState) => {
    let state = getState();
    let token = state.oidc.user.access_token;
    try {
      let apiService = new ApiService(token);
      const pumps = await apiService.getAll("stations/pumps");
      return pumps;
    }
    catch (ex) {
      console.error(ex);
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/stationActions.js